module.exports = __webpack_public_path__ + "static/table-maturity-930f55933f5e86ba5ac3a481754b4f6e.png";